import * as React from "react";
import Component from "../../AbstractComponent";
import Token from "../../../Token/Token";

export class Redirector extends Component {

  constructor(public props) {
    super(props);
  }

  public componentWillMount() {
    const token = Token.getInstant();

    if (!token) {
      return this.redirect("/auth/check-email");
    }

    return this.redirect("/app/dashboard/overview");
  }

  public render() {
    return <span></span>;
  }
}
